import React from 'react';

import RegisterView from './Register.view.tsx';

const Register = (props) => <RegisterView {...props} />;

export default Register;
